import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useUpdateNotificationBulkType = (): any => {
  const { data, isLoading, send } = useRequest({
    url: '/api/v1/notifications/bulk',
    method: ApiMethodsEnum.Patch,
    sendOnStart: false,
  });

  const updateNotificationBulkType = (body, successFunction: any) => {
    send(body).then((res) => {
      successFunction();
    });
  };

  return {
    isLoading,
    updateNotificationBulkType,
    data,
  };
};
